@use '../../styling/colors.scss' as *;

.Modal {
  position: absolute;
  background: $theme-color-slider-background;
  will-change: transform;
  outline: none;
  overflow: auto;
  box-shadow: 0 4px 16px 0 $color-dropdown-box-shadow;
}

.ModalContentFromRight {
  @extend .Modal;

  height: 100%;
  right: 0;

  // Initially, move the modal off to the right, so it is not visible
  transform: translateX(100%);
}

.ModalContentFromRightAfterOpen {
  // When the modal is open, move it to it's original position, so it is visible
  transform: translateX(0%);
}

.ModalContentFromRightBeforeClose {
  // When the modal is closed, move it off to the right to hide it again
  transform: translateX(100%);
}

.ModalContentFromLeft {
  @extend .Modal;

  height: 100%;

  // Initially, move the modal off to the left, so it is not visible
  transform: translateX(-100%);
}

.ModalContentFromLeftAfterOpen {
  // When the modal is open, move it to it's original position, so it is visible
  transform: translateX(0%);
}

.ModalContentFromLeftBeforeClose {
  // When the modal is closed, move it off to the left to hide it again
  transform: translateX(-100%);
}

.ModalContentFromBottom {
  @extend .Modal;

  bottom: 0;
  width: 100%;

  // Initially, move the modal off to the bottom, so it is not visible
  transform: translateY(100%);
}

.ModalContentFromBottomAfterOpen {
  // When the modal is open, move it to it's original position, so it is visible
  transform: translateY(0%);
}

.ModalContentFromBottomBeforeClose {
  // When the modal is closed, move it off to the bottom to hide it again
  transform: translateY(100%);
}

.ModalOverlay {
  z-index: 100;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  transition: background-color 0.5s;
}

.ModalOverlayAfterOpenLight {
  background-color: rgba($color-primary-black, 0.3);
}

.ModalOverlayAfterOpenDark {
  background-color: rgba($color-primary-black, 0.5);
}

.ModalOverlayBeforeClose {
  background-color: $color-transparent;
}
